import { IParsedCase } from '@/types/IParsedCase';
import { convertOldCategoryCodesToProcedure } from '@/utils/codes';
import { IXMedicusRequest } from './types';

export function parseRequest(request: IXMedicusRequest): IParsedCase {
  const noteId = request.note_id == null ? '' : String(request.note_id);
  return {
    external_id: request.external_id,
    ehr_note: request.note,
    existing_codes: convertOldCategoryCodesToProcedure(request?.existing_codes || []),
    // The EHR can deliver these as numbers even though the TS type says string;
    // the API declares them as `str | null` and Pydantic v2 rejects int (-> 422).
    // Coerce to string at the boundary in case the EHR sends a number.
    patient_id: request.person_id == null ? '' : String(request.person_id),
    cpr: request?.cpr || '',
    patient_firstname: request?.patient_firstname || '',
    patient_lastname: request?.patient_lastname || '',
    note_id: noteId,
    external_note_id: noteId,
    doctor_id: request.doctor_id == null ? '' : String(request.doctor_id),
    doctor_initials: request?.doctor_initials || '',
    consultation_type: request?.treatment || '',
    specialty: request?.doctor_specialty || '',
    location: request?.location,
  };
}
